import Vue from 'vue'
import store from './../store/index'

const container = {
  get: function () {
    return require('./../locales/countries-list/' + store.state.lang + '.json')
  },
  countryOptions () {
    const list = require('./../locales/countries-list/' + store.state.lang + '.json')
    const result = []
    for (const key in list) {
      result.push({
        value: key,
        text: list[key]
      })
    }

    return result
  }
}

const plugin = function (Vue, options) {
  Vue.prototype.$countriesList = container
  Vue.$countriesList = container
}

Vue.use(plugin)
